import { inject, Injectable } from '@angular/core';

import { toSignal } from '@angular/core/rxjs-interop';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';

import { MpsApiService } from '../../../mps/services/mps-api.service';
import { applicationEndpoints } from '../../application-endpoints';

interface IsManagerEoResponse {
  is_manager_eo: boolean;
}

@Injectable({ providedIn: 'root' })
export class ManagerEoService {
  private readonly _apiService = inject(MpsApiService);

  private readonly _isManagerEo$ = this._apiService
    .get<IsManagerEoResponse>(applicationEndpoints.adminUsersMeIsManagerEo)
    .pipe(
      map((response) => response.is_manager_eo),
      catchError(() => of(false)),
      shareReplay(1)
    );

  readonly isManagerEo = toSignal(this._isManagerEo$, { initialValue: false });

  checkIsManagerEo(): Observable<boolean> {
    return this._isManagerEo$;
  }
}
